import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";


// import moment from "moment";
import campaignResultDefaultImg from '../../../assets/images/campaignResult-default.png'
import './smtpLogResult.css'
import LeftArrowImg from '../../../assets/images/left-arrow.png'
import RightArrowImg from '../../../assets/images/right-arrow.png'


export class SmtpLogResult extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1

        }

    }


    getSmtpLogData = () => {

        let sortedArray = this.props.smtpLogs.slice(25 * this.state.currentPage - 25, 25 * this.state.currentPage)
        let JSX = [];
    

        sortedArray.forEach((entry) => {
            let message = { message: entry.description}

            
            JSX.push(<tr className="SmtpLogResult-value" key={entry.id}>
                <td className="SmtpLogResult-date-value">{entry.timestamp.split('.')[0].replace('T', ' ')}</td>
                <td className="SmtpLogResult-from-value">{entry.from}</td>
                <td className="SmtpLogResult-from-value">{entry.to.match(/([a-zA-Z0-9._+-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi)[0]}</td>
                <td className="SmtpLogResult-from-value">{entry.status ===0 ? "Bounced" : "Delivered"}</td>
                {entry.status===0 &&
                    
                <td className="SmtpLogResult-message-value"><Link to={{
                    pathname: "/showJson",
                    search: `${encodeURIComponent(JSON.stringify(message))}`
                }} target="_blank" rel="noopener noreferrer" > View Message</Link></td>
                }
                {entry.status===1 &&
                    <td className="SmtpLogResult-message-value">Success</td>
                }
                    

            </tr>)
        })

        return JSX;

    }

    moveNextPage = () => {
        if (this.state.currentPage < this.props.maxPage) {
            this.setState({ currentPage: this.state.currentPage + 1 })
        }
    }
    movePreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 })
        }
    }

    conditionalRendering = () => {
        if (this.props.smtpLogs) {
            return (<div className="SmtpLogResult">

                <div className="SmtpLogResult-log-details-container">
                    <table className="SmtpLogResult-log-details">
                        <thead>
                            <tr>
                                <th className="SmtpLogResult-date">Date</th>
                                <th className="SmtpLogResult-from">From</th>
                                <th className="SmtpLogResult-from">To</th>
                                <th className="SmtpLogResult-from">Status</th>
                                <th className="SmtpLogResult-message">Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getSmtpLogData(this.state.currentPage)}
                        </tbody>
                    </table>
                </div>
                <div className="SmtpLogResult-pagination">
                    <div className="SmtpLogResult-pagination-count">{this.state.currentPage} of {this.props.maxPage}</div>

                    <div className="SmtpLogResult-pagination-buttongroup">
                        <button className="SmtpLogResult-pagination-button-previous" onClick={this.movePreviousPage}>
                            <img src={LeftArrowImg} alt="Previous" ></img>
                        </button>
                        <button className="SmtpLogResult-pagination-button-next" onClick={this.moveNextPage}>
                            <img src={RightArrowImg} alt="Next" ></img>
                        </button>
                    </div>
                </div>

            </div>)
        } else {
            return (<div className="CampaignResult-default">
                <img src={campaignResultDefaultImg} alt="Default" />
                <div> Let The Search Begin!</div>
            </div>)
        }
    }



    render() {
        return (
            <React.Fragment>
                {this.conditionalRendering()}
            </React.Fragment>

        )
    }
}

const mapStateToProps = (state) => {
    if (state.logs.smtpLogs.logs && state.logs.smtpLogs.logs.length) {
        //showing 25 entries max per page
        return { searchTerm: state.logs.smtpLogs.searchTerm, smtpLogs: state.logs.smtpLogs.logs, maxPage: state.logs.smtpLogs.logs.length % 25 === 0 ? state.logs.smtpLogs.logs.length / 25 : Math.ceil(state.logs.smtpLogs.logs.length / 25) };
    } else {
        return { smtpLogs: null, maxPage: 1 }
    }
};

export default connect(mapStateToProps)(SmtpLogResult);
